import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import {
  fetchCompanyBillingDetailsStart,
  selectCompanyBillingDetails,
  selectCompanyDetailsError,
  selectIsCompanyDetailsLoading,
} from "@/store/features/companyDetails/companyDetails";

interface Company {
  id: string;
  name: string;
  type: string;
  billing_currency: string;
  billing_hourly_rate: number;
  billing_per_transaction_rate: string;
  // ... other company fields
}

export const useCompanyDetails = () => {
  const dispatch = useDispatch();
  const { companyId } = useParams<{ companyId: string }>();
  // Get active company ID from localStorage
  const activeCompanyId = localStorage.getItem('activeCompanyId');
  
  // Use the company ID from params or the active company ID from storage
  const targetCompanyId = companyId || activeCompanyId;

  // Select state from Redux store
  const companyBillingDetails = useSelector(selectCompanyBillingDetails);
  const isLoading = useSelector(selectIsCompanyDetailsLoading);
  const error = useSelector(selectCompanyDetailsError);
  const isError = error !== null; // Determine isError based on whether error exists

  // Fetch data when targetCompanyId changes
  useEffect(() => {
    if (targetCompanyId) {
      dispatch(fetchCompanyBillingDetailsStart(targetCompanyId));
    }
  }, [dispatch, targetCompanyId]);

  // Refetch function dispatches the start action again
  const refetch = React.useCallback(() => {
    if (targetCompanyId) {
      dispatch(fetchCompanyBillingDetailsStart(targetCompanyId));
    }
  }, [dispatch, targetCompanyId]);

  return {
    company: companyBillingDetails, // Renamed for consistency with original hook return
    isLoading,
    isError,
    error,
    refetch,
  };
}; 